import { cn } from "../../classNames-BzrkDnOD.js";
import { jsx } from "react/jsx-runtime";
import * as RLabel from "@radix-ui/react-label";
//#region src/components/Label/Label.tsx
/**
* Decorative optional marker (`(optional)`). Like `Label.Required` it is `aria-hidden`, so it is
* purely visual — optionality is conveyed by the *absence* of `aria-required`/`required` on the
* associated control, not by this text.
*/
const Optional = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	...props,
	"aria-hidden": true,
	className: cn("tw:ml-0.5", "tw:text-muted-foreground", className),
	children: "(optional)"
});
/**
* Decorative required marker (the `*`). It is `aria-hidden`, so it is purely visual and is **not**
* announced by assistive tech — conveying the requirement is the caller's responsibility: set
* `aria-required` (or `required`) on the associated control.
*/
const Required = ({ className, ...props }) => /* @__PURE__ */ jsx("span", {
	...props,
	"aria-hidden": true,
	className: cn("tw:ml-0.5", "tw:text-primary", className),
	children: "*"
});
const Label = ({ className, children, id, htmlFor, ...rest }) => /* @__PURE__ */ jsx(RLabel.Root, {
	...rest,
	id: id?.toString(),
	htmlFor: htmlFor?.toString(),
	className: cn("tw:m-0 tw:text-foreground tw:font-normal tw:peer-disabled:opacity-50", className),
	children
});
Label.Optional = Optional;
Label.Required = Required;
//#endregion
export { Label };

//# sourceMappingURL=Label.js.map